import { Component } from '@verndale/core';

class CalloutTwoColumn extends Component {
  setupDefaults() {
    this.dom = {
      leftCol: this.el.querySelector('.left-col') as HTMLElement,
      rightCol: this.el.querySelector('.right-col') as HTMLElement
    };

    if (this.el.dataset.leftCol) {
      const leftColWidth = Number(this.el.dataset.leftCol) / 10;
      (this.dom.leftCol as HTMLElement).classList.add(`col-xl-${leftColWidth}`);
    }

    if (this.el.dataset.rightCol) {
      const rightColWidth = Number(this.el.dataset.rightCol) / 10;
      (this.dom.rightCol as HTMLElement).classList.add(`col-xl-${rightColWidth}`);
    }
  }

  addListeners() {}
}

export default CalloutTwoColumn;
